import React, {ChangeEvent, useState} from "react";
import { deleteProps } from "../../../../../utils/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faSpinner, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import DeleteButton from "../../../buttons/manage-jdl/deleteButton";

const DeleteModalContent : React.FC<deleteProps> = ({id, name, endPoint}) => {

    const [confirmed, setConfirmed] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [deleted, setDelete] = useState<boolean | null>(null);

    const handleCheckboxChange = (e : ChangeEvent<HTMLInputElement>) => {
        setConfirmed(e.target.checked);
    };

    if(loading){
        return (
            <div className="flex justify-center items-center my-8">
                <FontAwesomeIcon icon={faSpinner} className="text-4xl text-gray-600 animate-spin" />
            </div>
        )
    }

    if(deleted === true){
        return(
            <div className="flex justify-center items-center my-8 text-xl">
                <FontAwesomeIcon icon={faCheckCircle} className="text-green-600" />
                {name} Deleted
            </div>
        )
    }

    if(deleted === false){
        return(
            <div className="flex justify-center items-center my-8 text-xl">
                <FontAwesomeIcon icon={faTimesCircle} className="text-red-500" />
                An error occured!
            </div>
        )
    }

    return(
        <div className="py-2 px-4">
            <div className="mb-4">
                <FontAwesomeIcon className="text-red-500" icon={faTimesCircle} />&nbsp;
                Delete {name} ?
            </div>
            <div className="text-gray-600 text-xl">
                This Process cannot be undone.
            </div>
            <div className="my-3 flex gap-2">
                <input onChange={handleCheckboxChange} type="checkbox" />
                <p>Confirm deletion.</p>
            </div>
            <div>
                <DeleteButton id={id} isConfirmed={confirmed} onDelete={(value)=>setDelete(value)} onLoad={(value)=>setLoading(value)} endPoint={endPoint} />
            </div>
        </div>
    );
}

export default DeleteModalContent;